import { BaseService } from 'services/baseService';
import { TechnologyModel } from 'types/models/TechnologyModel';

class TechnologyService extends BaseService<TechnologyModel> {
  controllerName = 'technologies';
}

export const technologyService = new TechnologyService();
